import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
    selector: 'in-standard-form-panel',
    templateUrl: './standard-form-panel.component.html',
    styleUrls: ['./standard-form-panel.component.scss'],
    standalone: false
})
export class StandardFormPanelComponent implements OnInit {
  @Input() updatePrivilege? = true;
  @Input() buttons: { save?: string | boolean; create?: string | boolean; copy?: string | boolean; delete?: string | boolean; deleteFile?: string | boolean; operatingmode?: string | boolean; timeschedule?: string | boolean; upload?: string; view?: string; extcommand?: string | boolean} = {};
  // tslint:disable-next-line:max-line-length
  @Input() buttonsLabels: { save?: string; create?: string; copy?: string; delete?: string; deleteFile?: string;
    savetitle?: string; operatingmode?: string; timeschedule?: string; upload?: string; view?: string;
    extcommand?: string; extcommandtitle?: string; } =
    // tslint:disable-next-line:max-line-length
    {save: 'SAVE', create: 'CREATE', copy: 'COPY', delete: 'DELETE', deleteFile: 'DELETE FILE', operatingmode: 'OPERATINGMODE', timeschedule: 'TIMESCHEDULE', upload: 'UPLOAD', view: 'VIEW',
      extcommand: 'EXT COMMAND', extcommandtitle: 'Exec command'};
  // tslint:disable-next-line:max-line-length
  @Input() buttonsColor: { save?: string; create?: string; copy?: string; delete?: string; deleteFile?: string; savetitle?: string; operatingmode?: string; timeschedule?: string; upload?: string; view?: string; extcommand?: string } =
    // tslint:disable-next-line:max-line-length
    {save: 'primary', create: 'primary', copy: 'primary', delete: 'primary', deleteFile: 'primary', operatingmode: 'primary', timeschedule: 'primary', upload: 'primary', view: 'primary', extcommand: 'primary'};
  // tslint:disable-next-line:max-line-length
  @Input() disable: { save?: string | boolean; create?: string| boolean; copy?: string| boolean; delete?: string| boolean; deleteFile?: string| boolean; operatingmode?: string| boolean; timeschedule?: string| boolean; upload?: string| boolean; view?: string| boolean; extcommand?: string| boolean } = {};
  @Input() accept?: string = null;
  @Input() fullSize = false;
  @Input() fullHeight = false;
  @Output() save = new EventEmitter<any>();
  @Output() create = new EventEmitter<any>();
  @Output() duplicate = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() view = new EventEmitter<any>();
  @Output() deleteFile = new EventEmitter<any>();
  @Output() operatingmode = new EventEmitter<any>();
  @Output() timeschedule = new EventEmitter<any>();
  @Output() upload = new EventEmitter<any>();
  @Output() extcommand = new EventEmitter<any>();


  @ViewChild('fileInput', {static: false}) el: ElementRef;
  file: File = null;


  constructor() {
  }

  ngOnInit() {
    return;
  }

  public onSave() {
    this.save.next({});
  }
  public onCreate() {
    this.create.next({});
  }

  public onDuplicate() {
    this.duplicate.next({});
  }

  public onDelete() {
    this.delete.next({});
  }

  public onView() {
    this.view.next({});
  }

  public onOperatingMode() {
    this.operatingmode.next({});
  }

  public onTimeSchedule() {
    this.timeschedule.next({});
  }

  public onExtcommand() {
    this.extcommand.next({});
  }

  onClickChoose() {
    this.el.nativeElement.click();
  }

  onChangeFile(e, fileInput) {
    e.preventDefault();
    if (e.target.files[0]) {
      this.file = e.target.files[0];
      this.upload.emit(e.target);
    }
    this.file = null;
    this.el.nativeElement.value = '';
  }

}
